import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import { attachment } from "features/insuranceDocument/queries/fragments";

export const ATTACHMENTS_RETRIEVED = gql`
  subscription attachmentsRetrieved($documentId: Int!) {
    attachmentsRetrieved(documentId: $documentId) {
      attachmentData {
        documentId
        attachments {
          ...attachment
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${attachment}
  ${messageHeaders}
`;

export const ATTACHMENTS_ADDED = gql`
  subscription attachmentsAdded {
    attachmentsAdded {
      attachmentData {
        documentId
        attachments {
          ...attachment
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${attachment}
  ${messageHeaders}
`;

export const ATTACHMENT_UPDATED = gql`
  subscription attachmentUpdated {
    attachmentUpdated {
      attachment {
        ...attachment
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${attachment}
  ${messageHeaders}
`;

export const ATTACHMENT_DELETED = gql`
  subscription attachmentDeleted {
    attachmentDeleted {
      documentAttachmentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const ATTACHMENT_STATE_CHANGED = gql`
  subscription attachmentStateChanged {
    attachmentStateChanged {
      attachment {
        ...attachment
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${attachment}
  ${messageHeaders}
`;

export const REQUIRED_DOC_TYPES_COMPUTED = gql`
  subscription requiredDocTypesComputed {
    requiredDocTypesComputed {
      requiredDocTypes {
        id
        documentName
        contextName
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
